import authLink from './authLink';
import unauthorizedErrorLink from './unauthorizedErrorLink';

export default [authLink, unauthorizedErrorLink];
